<div class="d-flex justify-content-center">
  <div
    class="spinner-border"
    role="status"
    [attr.width]="width"
    [attr.height]="height"
    [attr.color]="color"
  ></div>
</div>
